/**
 * Run PMW main loader
 */

const main = async () => {

	require("./pmw/functions_main");
	require("./version.js");

	// Wait until jQuery is loaded
	await pmw.jQueryExists();

	// Wait until pmwDataLayer is loaded
	await pmw.dataLayerFullyLoaded();

	/**
	 * Set webpack public path for chunk loading
	 * This ensures chunks load correctly even when scripts are combined/moved 
	 * by optimization plugins (SiteGround, Autoptimize, WP Rocket, etc.)
	 */
	if (pmwDataLayer?.general?.chunk_base_path) {
		// eslint-disable-next-line no-undef, camelcase
		__webpack_public_path__ = pmwDataLayer.general.chunk_base_path;
	}

	// wait 1000ms
	// await new Promise(resolve => setTimeout(resolve, 1000))

	// Load all essential scripts first
	require("./pmw/functions_loader");

	// Initialize cross-tab session sync early so that session data
	// from existing tabs is available before event listeners run
	if (pmw.crossTabSync) {
		pmw.crossTabSync.init();
		window.addEventListener("beforeunload", () => pmw.crossTabSync.cleanup());
	}
	
	// Load new event filtering system
	require("./pmw/hooks");
	require("./pmw/pixel-registry");
	require("./pmw/event-processor");

	// Initialize command queue early so filters can be registered before events fire
	pmw.initializeCommandQueue();

	// Output PMW console message
	pmw.pmwConsoleMessage();

	// Load the consent management module as a chunk
	await pmw.loadConsentModule();
	await pmw.consent.load();

	// Doesn't work if we listen to pmw:dom:ready because it runs too late
	// (at the end of the main.js file)
	// TODO: Find out why that order is important and optimize it. It is also difficult to test. In Cypress it works just with "pmw:dom:ready"
	jQuery(() => {
		require("./pmw/event_listeners_on_ready");
	});

	// Load remaining event listeners
	require("./pmw/event_listeners");
	
	// Load doofinder listener as a chunk
	import(/* webpackChunkName: "doofinder-listener" */ "./pmw/listeners/doofinder");

	pmw.loadWcHooksFunctions();

	// Check if domain is excluded from tracking
	// If so, return
	if (pmw.excludeDomainFromTracking()) return;

	// Load pixels dynamically based on configuration
	const pixelLoaders = [];

	// Load free pixels conditionally
	if (pmwDataLayer?.pixels?.google) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-google" */ "./pixels/google/loader")
		);
	}
	
	if (pmwDataLayer?.pixels?.facebook) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-facebook" */ "./pixels/facebook/loader")
		);
	}
	
	if (pmwDataLayer?.pixels?.hotjar) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-hotjar" */ "./pixels/hotjar/loader")
		);
	}

	if (pmwDataLayer?.pixels?.crazyegg) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-crazyegg" */ "./pixels/crazyegg/loader")
		);
	}

	// #if process.env.TIER === 'premium'
	/**
	 *  Load premium pixels conditionally
	 */
	if (pmw.canLoadPremiumFeatures()) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pmw-premium-events" */ "./pmw/event_listeners_premium")
		);

		if (pmwDataLayer?.pixels?.contentsquare) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-contentsquare" */ "./pixels/contentsquare/loader")
			);
		}

		if (pmwDataLayer?.pixels?.adroll) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-adroll" */ "./pixels/adroll/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.linkedin) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-linkedin" */ "./pixels/linkedin/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.bing) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-microsoft" */ "./pixels/microsoft-ads/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.outbrain) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-outbrain" */ "./pixels/outbrain/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.pinterest) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-pinterest" */ "./pixels/pinterest/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.snapchat) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-snapchat" */ "./pixels/snapchat/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.taboola) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-taboola" */ "./pixels/taboola/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.tiktok) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-tiktok" */ "./pixels/tiktok/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.twitter) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-twitter" */ "./pixels/twitter/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.reddit) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-reddit" */ "./pixels/reddit/loader")
			);
		}
		
		if (pmwDataLayer?.pixels?.vwo) {
			pixelLoaders.push(
				import(/* webpackChunkName: "pixel-vwo" */ "./pixels/vwo/loader")
			);
		}
	}
	// #endif

	// Load all active pixels in parallel
	await Promise.all(pixelLoaders);

	/** Load the deprecated functions as a chunk (if enabled) */
	if (pmwDataLayer?.general?.modules?.load_deprecated_functions !== false) {
		const {loadDeprecatedFunctions} = await import(/* webpackChunkName: "deprecated-functions" */ "./pmw/deprecated.mjs");
		loadDeprecatedFunctions();
	}

	// Preload pixels
	document.dispatchEvent(new Event("pmw:load-pixels"));

	// Trigger pmwLoad event
	document.dispatchEvent(new Event("pmwLoad"));

	// Wait until page is loaded
	await pmw.pageLoaded();

	document.dispatchEvent(new Event("pmw:ready"));
	pmw.triggerPmwDomReadyEvent();

	// Check if the library version matches the PMW version that's installed on the server
	pmw.checkLibraryVersion();
};

main();








